import { Component, ViewEncapsulation, inject } from '@angular/core';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

export interface GenericSnackbarData {
    messages: string[];
    showDismissButton: boolean;
}

@Component({
    selector: 'r1-generic-snackbar',
    template: `
        <div class="generic-snack-bar-container">
            @for (message of data.messages; track $index) {
                <div class="generic-snack-bar-message-container">
                    {{ message }}
                </div>
            }
            @if (data.showDismissButton) {
                <div>
                    <button mat-flat-button class="button-white" (click)="onDismiss()" type="button">Dismiss</button>
                </div>
            }
        </div>
    `,
    styleUrls: ['./generic-snackbar.component.scss'],
    imports: [MatButtonModule],
    encapsulation: ViewEncapsulation.None,
})
export class GenericSnackbarComponent {
    readonly #matSnackBarService = inject(MatSnackBar);
    readonly data = inject<GenericSnackbarData>(MAT_SNACK_BAR_DATA);

    onDismiss(): void {
        this.#matSnackBarService.dismiss();
    }
}
